import React, { CSSProperties } from 'react';
import { ProductType } from '../types';
import { Typography, Tag } from 'antd';

const { Title, Text, Paragraph } = Typography;

type Props = {
  item: ProductType;
  containerStyle?: CSSProperties;
};

export const ProductPrice: React.FC<Props> = ({ containerStyle, item }) => {
  return (

    <div style={{ marginBottom: 16 }}>
      {item.off_percentage ? (
        <>
          <div className="flex flex-wrap items-baseline mt-2 gap-x-2 gap-y-1">
            <span className="text-gray-400 text-sm line-through" style={{ fontSize: 10 }}>
            {item.price.toLocaleString()} تومان
            </span>
            <span className="text-red-600 text-xl font-semibold" style={{ fontSize: 12 }}>
              {item.off_price.toLocaleString()} تومان
            </span>
            <Tag color="red" className="rounded-full w-fit">
              {item.off_percentage} %
            </Tag>
          </div>
        </>
      ) : (
        <Text strong style={{ fontSize: 10 }}>
          {item.price.toLocaleString()} تومان
        </Text>
      )}
    </div>
  );
};
